<template>
  <div>
    <!-- <h1>The Home Component</h1>
    <h2>MONEY! ${{ funds }}</h2> -->
    <!-- <div class="cheetah row">
      <div class="col-lg-6 my-auto" style="padding-right: 100px;">
        <h1 style="text-align: right; color: #183a52; font-family: 'Open Sans'; font-weight: 800; font-size: 50px;">Be your best.</h1>
      </div>
      <div class="col-lg-6 pr-5">
        <img src="../assets/img/home/cheetah_blue_left.png" alt="cheetah" style="padding-right: 0px;" id="cheetah">
      </div>
    </div> -->
    <!-- <div class="cheetah row">
      <div class="col-lg-6 my-auto pl-5 pr-4" style="">
        <p style="text-align: left; color: #183a52; font-size: 18px;">“Running isn’t a sport for pretty boys… It’s about the sweat in your hair and the blisters on your feet. It’s the frozen spit on your chin and the nausea in your gut. It’s about throbbing calves and cramps at midnight that are strong enough to wake the dead. It’s about getting out the door and running when the rest of the world is only dreaming about having the passion that you need to live each and every day with. It’s about being on a lonely road and running like a champion even when there’s not a single soul in sight to cheer you on. Running is all about having the desire to train and persevere until every fiber in your legs, mind, and heart is turned to steel. And when you’ve finally forged hard enough, you will have become the best runner you can be. And that’s all that you can ask for.”</p>
        <p style="color: #183a52; font-weight: 700;">Paul Maurer</p>
      </div>
      <div class="col-lg-6 pr-5" style="height: 100vh;">
        <img src="../assets/img/home/cheetah_blue_left.png" alt="cheetah" style="padding-right: 0px;" id="cheetah">
      </div>
    </div> -->

    <!-- <div class="cheetah row web-only">
      <div class="col-lg-6 my-auto pl-5 pr-4" style="line-height: 1.2;">
        <p style="text-align: left; color: #183a52; font-size: 38px; line-height: 1.2; margin-bottom: 25px;">Be the best that you can be.</p>
        <router-link v-if="!auth" to="/login" class="btn btn-primary">SIGN IN</router-link>
        <router-link v-if="!auth" to="/register" class="btn btn-primary">SIGN UP</router-link>
      </div>
      <div class="col-lg-6 pr-5" style="height: calc(100vh - 30px);">
        <img src="../assets/img/home/cheetah_blue_left_compressed.png" alt="cheetah" class="pt-4" style="padding-right: 0px; max-width: 100%;" id="cheetah">
      </div>
    </div> -->

    <div class="web-only landing">
      <div style="padding-top: 20%; padding-left: 6%;">
        <h2>Just Keep Running</h2>
        <h5 class="" style="margin-bottom: 30px;">With Allison Ryan</h5>
        <!-- <router-link v-if="!auth" to="/login" class="btn btn-primary">SIGN IN</router-link> -->
        <!-- <router-link v-if="!auth" to="/register" class="btn btn-primary">SIGN UP</router-link> -->
        <router-link v-if="!auth" to="/login" class="mylisting-button dark-button">SIGN IN</router-link>
        <router-link v-if="!auth" to="/register" class="mylisting-button dark-button">SIGN UP</router-link>
      </div>
    </div>

    <div class="mobile-only">
      <div class="mt-3" style="line-height: 1.1;">
        <p class="px-4" style="text-align: center; color: #183a52; font-size: 38px; line-height: 1.1; margin-bottom: 5px;">Just Keep Running</p>
        <div style="width: 100vw; display: block; margin-left: auto; margin-right: auto;" class="mt-4">
          <router-link style="display: block; margin-left: auto; margin-right: auto; max-width: 160px;" v-if="!auth" to="/login" class="btn btn-primary">SIGN IN</router-link>
          <router-link style="display: block; margin-left: auto; margin-right: auto; max-width: 160px;" v-if="!auth" to="/register" class="btn btn-primary mt-1">SIGN UP</router-link>
        </div>

      </div>
      <div class="pl-5" style="">
        <img src="../../../assets/img/home/cheetah_blue_left_compressed.png" alt="cheetah" class="pt-4" style="max-width: 100%;" id="">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    computed: {
      funds() {
        return this.$store.getters.funds;
      },
      auth () { // Lecture 363
        return this.$store.getters.isAuthenticated
      },
    }
  }
</script>

<style>

  .cheetah img {
    /* max-height: 500px; */
    /* max-height: 100vh; */
    /* width: 100%; */
    text-align: right;
    /* display: block; */
    margin-left: auto;
    float: right;
    /* margin-right: auto; */
  }

  .landing {
    margin: -15px;
    /* margin-top: -15px; */
    /* margin-bottom: -15px; */
    /* margin-left: -15px; */

    height: 100vh;
    /* background: url('../assets/img/home/VegNews.ScottJurek.VND.jpg') left center; */
    background: url('../../../assets/img/home/AdobeStock_43285502_flipped_resized_compressed.jpg') left center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    background-repeat: no-repeat;


  }

</style>



// WEBPACK FOOTER //
// src/components/myrundash/teamlandings/JustKeepRunning.vue